import { ftFabricateAllowsTargetlessCast } from '../port/k3-rules/fabricate_on_cast.js';
import { fabricateRows } from '../actions/ability-preconditions.js';
import { browserDependencies } from '../port/browser-dependencies.js';
import { definitionNotHeld, itemField, record, upper, type JanusReaders, type Row } from './context.js';

export type FabricationReaders = Pick<JanusReaders, 'value' | 'entries' | 'definition'>;
export const fabricationEnvironment = (read: FabricationReaders) => browserDependencies({
  item_field: (row: unknown, key: string) => itemField(record(row), key),
  layer_value: (row: unknown, key: string) => read.value(record(row), key),
  layer_entries: (row: unknown, key: string) => read.entries(record(row), key),
  ft_fabricate_rows: (entries: unknown) => fabricateRows(Object.values(entries ?? {})).map(row =>
    ({ item_uuid: row.uuid, template_id: row.template, qty: row.qty })),
  query_full_item_arr: (id: string) => read.definition(upper(id)),
});

/** Dispatch needs the port's targetless gate without loading the inventory grant pipeline. */
export function fabricationAllowsTargetlessCast(ability: Row, phase: unknown, read: FabricationReaders): boolean {
  // An unheld finish output is a data gap, never proof that its saved empty selection was illegal.
  if (['finish_casting', 'finish_casting_ritual_spell'].includes(String(phase)))
    for (const output of fabricateRows(read.entries(ability, 'fabricate')))
      if (!read.definition(upper(output.uuid))) definitionNotHeld('fabricate:output-definition-not-held', output.uuid);
  return ftFabricateAllowsTargetlessCast(ability, phase, fabricationEnvironment(read));
}
